// Constants use for maps
export const MAP = {
    MAGIC_SCALE: 50,
};
